<template>
  <a-modal
    :title="title"
    width="95%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :dialogStyle="{ left: 0, top: mTop + 'px', verticalAlign: 'top', height: '80%' }"
    centered
    @cancel="cancleCallback"
    :footer="null"
  >
    <div>
      <v-pdf :pdfUrl="pdfUrl" max="tMax"></v-pdf>
    </div>
  </a-modal>
</template>
<script>
import { api } from '@/api/public'
import pdf from '@/components/pdf/pdf.vue'
import { getStore, SPF } from '@/utils/storage'
export default {
  name: 'PdfModule',
  components: {
    'v-pdf': pdf
  },
  created() {
    // this.mwidth = document.body.clientWidth * 0.96
    this.mTop = document.body.clientHeight * 0.01
    this.mHeight = document.body.clientHeight * 0.92
  },
  data() {
    return {
      mwidth: 1200,
      mHeight: 900,
      mTop: 30,
      title: '',
      type: '',
      visible: false,
      confirmLoading: false,
      pdfUrl: '',
      tMax: 0
    }
  },
  methods: {
    cancleCallback() {
      const _that = this
      _that.pdfUrl = ''
      _that.tMax = 0
      _that.visible = false
    },
    //打开弹框
    OpenEmPdf(file) {
      const _that = this
      //获取路径
      const res = getStore(SPF.API)
      _that.visible = true
      _that.pdfUrl = (res ? '/' + res.substring(res.indexOf('@') + 1) : '') + api.fileDownload + '?id=' + file.id
      console.log('_that.pdfUrl', _that.pdfUrl)
    }

    // _that.pdfUrl = record.fileurl
  }
}
</script>
